export default function() {
	document.querySelectorAll('.hidden-link').forEach(function (item) {
		item.addEventListener('click', function () {
			let openType = this.classList.contains('hidden-link-blank') ? "_target"  : "_self"
			window.open(this.getAttribute('data-link'), openType);

			return false;
		})
	})
}	